import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'CircleDottedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-dotted",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7.5 4.21l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4.21 7.5l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 12l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4.21 16.5l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7.5 19.79l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 21l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16.5 19.79l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M19.79 16.5l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M21 12l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M19.79 7.5l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16.5 4.21l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 3l0 .01"
    }, null), _createTextVNode(" ")]);
  }
};